import { Pipe, PipeTransform } from '@angular/core';
import { differenceInYears, parseISO } from 'date-fns';

@Pipe({
  name: 'age',
  standalone: true
})
export class AgePipe implements PipeTransform {
  transform(birthday: any, ...args: unknown[]): number {
    return differenceInYears(new Date(), new Date(birthday)) || 0;
  }
}
